export default __webpack_public_path__ + "pgnv-assets/5313edeff41aa028ed440ca6c6366b7a.png";